import React from 'react';
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Divider,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

const Signin = ({
  strings,
  handleSignup,
  handleSignIn,
  handleManagerIn,
  onChange,
  state,
  error,
}) => {
  const userIdFeedBack = error ? !!('userId' in error && error.userId) : false;
  const passwordFeedBack = error
    ? !!('password' in error && error.userpasswordId)
    : false;
  const loginFeedBack = error ? 'login' in error && error.login : null;
  const inputComplete =
    state.userId &&
    state.password &&
    state.password.length > 7 &&
    !passwordFeedBack &&
    !userIdFeedBack;

  const handleKeyUp = (e) => {
    const { key, keyCode } = e;
    if (inputComplete && (key === 'Enter' || keyCode === 13)) {
      handleSignIn();
    }
  };

  return (
    <Container sx={{ margin: 'auto' }} maxWidth="xs">
      <Card>
        <CardContent>
          <Stack
            sx={{ width: '100%', alignItems: 'center', padding: '16px 0' }}
            spacing={2}
          >
            <Typography variant="h6">{strings.title}</Typography>
            <Stack
              sx={{ width: '80%', alignSelf: 'center', padding: '16px 0' }}
              spacing={2}
            >
              <TextField
                name="userId"
                label={strings.userIdLabel}
                helperText={strings.userIdPlaceholder}
                value={state.userId}
                onBlur={onChange}
                onChange={onChange}
                onKeyUp={handleKeyUp}
                error={userIdFeedBack}
              />
              <TextField
                name="password"
                type="password"
                label={strings.passwordLabel}
                helperText={strings.passwordPlaceholder}
                value={state.password}
                onBlur={onChange}
                onChange={onChange}
                onKeyUp={handleKeyUp}
                error={passwordFeedBack}
              />
            </Stack>
            {loginFeedBack && (
              <Alert severity="error" sx={{ margin: '16px 0' }}>
                {loginFeedBack}
              </Alert>
            )}
            <Box sx={{ width: '80%', paddingTop: '16px' }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleSignIn}
                fullWidth
              >
                로그인
              </Button>
              <Divider sx={{ margin: '16px 0' }}>OR</Divider>
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleSignup}
                fullWidth
              >
                회원가입
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                fullWidth
                sx={{ mt: 2 }}
                onClick={handleManagerIn}
              >
                로봇 시리얼로 로그인
              </Button>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </Container>
  );
};

export default Signin;
